// extracted by mini-css-extract-plugin
export default {"collapse":"statusChangeLog_collapse__uN24i","panelHeader":"statusChangeLog_panelHeader__OwbLH","spin":"statusChangeLog_spin__AB5Si","avatar":"statusChangeLog_avatar__RdEzf"};